import React from 'react';
import styled from 'styled-components';

import { Row, Col } from 'components/layout';
import Card from 'components/Card';
// import Statistics from 'components/Statistics';

// import { GoalsBarSection } from './BarSection';
// import GoalsBar from './GoalsBar';
// import GoalsDetails from './GoalsDetails';
// import PointsDetails from './PointsDetails';
import StatsCardGroup from './StatsCard';
import { formatDuration } from 'helpers/date';

import WorkingShiftsChart from './Stats/WorkingShiftsChart';
import WorkSegmentsBySpeedChart from './Stats/WorkSegmentsBySpeedChart';
import Tooltip from 'antd/es/tooltip';
import Icon from 'components/Icon';
import Spin from 'antd/es/spin';
import {
  SHIFTS_TOOLTIP_TITLE,
  INBOUND_PERFORMANCE_TOOLTIP_TITLE,
} from './tooltipContent';

// const StyledIndividualStatsCard = styled(Card)`
//   & > .ant-card-body {
//     // padding: 0;
//   }
// `;

const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 12px;
`;

const StyledStatsCard = styled(StatsCardGroup)`
  border: 1px solid #EFF2F5;

  & > .ant-card-body {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    gap: 8px;
  }

  & .ant-statistic {
    flex: 1 1 0;
    align-items: center;
    text-align: center;
  }

  & .ant-statistic-title {
    color: #000;
    font-size: 13px;
    white-space: normal;
    line-height: 18px;
    margin-top: 4px;
    min-height: 36px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  & .ant-statistic-content-value-decimal {
    font-size: inherit;
    line-height: inherit;
  }

  & .ant-divider-vertical {
    display: inline-block;
    align-self: stretch;
    border-left: 2px solid #EFF2F5;
    margin: 0 20px;
  }
`;

// const IndividualStatistics = styled(Statistics)`
//   & > .ant-statistic-title {
//     font-family: Inter;
//     font-style: normal;
//     font-weight: normal;
//     font-size: 14px;
//     line-height: 22px;
//     color: #000;

//     ${props => props.titleStyle}
//   }

//   & > .ant-statistic-content-value {
//     font-family: Inter;
//     font-style: normal;
//     font-weight: 600;
//     font-size: 24px;
//     line-height: 32px;
//     color: #000;
//   }
// `;

const formatNumber = (val) => {
  const n = Number(val || 0);
  if (Number.isNaN(n)) return '0';
  return n.toLocaleString();
};

// Props: { data, loading }
// data comes from reports/individual-details
const IndividualPeriodStats = ({ data, loading = false }) => {
  // const [showGoalsDetails, setShowGoalsDetails] = useState(false);
  // const {
  //   loadsAndUnloads,
  //   individual,
  //   scores,
  //   settings,
  //   isAgency,
  // } = props;

  // const {
  //   boxes_unloaded,
  //   unloaded_volume,
  //   min_cph,
  //   max_cph,
  //   avg_cph,
  // } = individual || {};

  // const {
  //   // -- attendance
  //   attendance_tot = 0,
  //   max_attendance_days = 0,

  //   // -- hours worked
  //   hrs_worked_tot,

  //   // -- saved time
  //   saved_mins_tot,
  //   saved_mins_net,

  //   // -- goals
  //   goals_completed_tot = 0,
  //   goals_tot = 0,
  // } = scores;

  // const unloads = loadsAndUnloads.filter(l => {
  //   return l.direction === 'UNLOAD';
  // });

  const shiftsSegmentsStats = (Array.isArray(data?.shifts_segments_stats) && data.shifts_segments_stats[0]) || {};
  const totShifts = Number((data?.tot_shifts?.tot_shifts) || 0);

  const workingShifts = Number(shiftsSegmentsStats.working_shifts || 0);
  const workSegmentsBySpeedData = [
    { type: 'FAST', value: Number(shiftsSegmentsStats.tot_fast_segments || 0) },
    { type: 'NORMAL', value: Number(shiftsSegmentsStats.tot_normal_segments || 0) },
    { type: 'SLOW', value: Number(shiftsSegmentsStats.tot_slow_segments || 0) },
    { type: 'NOT MEASURED', value: Number(shiftsSegmentsStats.tot_not_measured_segments || 0) },
  ];

  const avgCph = Number(shiftsSegmentsStats.avg_cph || shiftsSegmentsStats.avg_cph_manual || 0);
  const totSegments = Number(shiftsSegmentsStats.tot_segments || 0);
  const timeSavedHrs = shiftsSegmentsStats.tot_saved_hrs;
  const timeLostHrs = shiftsSegmentsStats.tot_lost_hrs;
  const totalTimeDetectedHrs = shiftsSegmentsStats.total_time_detected || shiftsSegmentsStats.total_time_tedected;
  const netSavingsHrs = (typeof timeSavedHrs === 'number' ? timeSavedHrs : 0) - (typeof timeLostHrs === 'number' ? timeLostHrs : 0);

  return (
    // <StyledIndividualStatsCard>
    //   <Row gutter={24}>
    //     <Col span={10}>
    //       <Row justify="center" align="middle" style={{ padding: '16px 0 24px 0' }}>
    //         <Progress
    //           type="circle"
    //           percent={Math.round(attendance_tot * 100) / max_attendance_days}
    //           strokeColor="#000912"
    //           trailColor="#E4E8ED"
    //           strokeWidth={12}
    //           strokeLinecap="square"
    //           width={200}
    //           format={() => (
    //             <IndividualStatistics
    //               title={'attendance on selected period'}
    //               value={`${Math.round(attendance_tot)}/${Math.round(max_attendance_days)}`}
    //               titleAlign={['center', 'bottom']}
    //               titleStyle={{
    //                 maxWidth: '100px'
    //               }}
    //               valueStyle={{
    //                 fontSize: '30px',
    //                 lineHeight: '38px',
    //               }}
    //             />
    //           )}
    //         />
    //       </Row>
    //     </Col>
    //     <Col span={14}>
    //       <Row>
    //         <Col span={24}>
    //           <GoalsBarSection
    //             title="Targets"
    //             value={`${Math.round(goals_completed_tot)}/${Math.round(goals_tot)}`}
    //             description="Targets on selected period"
    //             help="How it is calculated"
    //             helpTitle="How targets get’s calculated"
    //             helpMessage={(
    //               <Text style={{ fontSize: '14px', lineHeight: '22px' }}>
    //                 Unload targets for selected period where the individuals have participated more than {settings.min_participation * 100}% of the overall unload time.<br /><br />
    //                 <Link target="_blank" to="/settings#p4p">Change P4P settings</Link>
    //               </Text>
    //             )}
    //             helpModalProps={{
    //               width: '530px',
    //             }}
    //             onDetails={() => {
    //               setShowGoalsDetails(true);
    //             }}
    //           >
    //             <GoalsBar
    //               value={Math.round(goals_completed_tot)}
    //               total={Math.round(goals_tot)}
    //               style={{ height: '24px' }}
    //             />
    //           </GoalsBarSection>
    //         </Col>
    //       </Row>
    //       <Row>
    //         <Col span={24}>
    //           <Divider
    //             orientation="center"
    //             type="horizontal"
    //             style={{
    //               width: '85%'
    //             }}
    //           />
    //         </Col>
    //       </Row>
    //       <Row justify="space-between">
    //         <Col>
    //           <TotalStatistics
    //             title="Total time detected"
    //             titleAlign={['center', 'top']}
    //             value={hrs_worked_tot !== undefined ? formatDuration(hrs_worked_tot * 3600000, false) : '-'}
    //           />
    //         </Col>
    //         <Col>
    //           <TotalStatistics
    //             title="Saved time"
    //             titleAlign={['center', 'top']}
    //             value={saved_mins_tot !== undefined ? formatDuration(saved_mins_tot * 60000, false) : '-'}
    //           />
    //         </Col>
    //         <Col>
    //           <TotalStatistics
    //             title="Net savings"
    //             titleAlign={['center', 'top']}
    //             value={saved_mins_net !== undefined ? formatDuration(saved_mins_net * 60000, false) : '-'}
    //           />
    //         </Col>
    //       </Row>
    //     </Col>
    //   </Row>
    //   <Row>
    //     <Col span={24}>
    //       <Divider
    //         orientation="center"
    //         type="horizontal"
    //         style={{
    //           width: '85%'
    //         }}
    //       />
    //     </Col>
    //   </Row>
    //   <Row gutter={24} align="stretch">
    //     <Col span={11}>
    //       <StyledStatsCard
    //         statistics={[
    //           {
    //             title: 'Cartons unloaded with other team members',
    //             value: typeof boxes_unloaded === 'number'
    //               ? Math.round(boxes_unloaded)
    //               : '-',
    //             titleAlign: ['center', 'bottom']
    //           },
    //           {
    //             title: 'Volume unloaded with other team members',
    //             value: typeof unloaded_volume === 'number'
    //               ? `${Math.round(unloaded_volume)}cbm`
    //               : '-',
    //             titleAlign: ['center', 'bottom']
    //           },
    //         ]}
    //       />
    //     </Col>
    //     <Col span={13}>
    //       <StyledStatsCard
    //         statistics={[
    //           {
    //             title: 'Min CPH ',
    //             value: typeof min_cph === 'number' ? Math.round(min_cph) : '-',
    //             titleAlign: ['center', 'bottom']
    //           },
    //           {
    //             title: 'Max CPH',
    //             value: typeof max_cph === 'number' ? Math.round(max_cph) : '-',
    //             titleAlign: ['center', 'bottom']
    //           },
    //           {
    //             title: 'Average CPH',
    //             value: typeof avg_cph === 'number' ? Math.round(avg_cph) : '-',
    //             titleAlign: ['center', 'bottom']
    //           }
    //         ]}
    //       />
    //     </Col>
    //   </Row>

    //   <Drawer
    //     title="Targets current period"
    //     placement="right"
    //     closable={true}
    //     onClose={() => {
    //       setShowGoalsDetails(false);
    //     }}
    //     visible={showGoalsDetails}
    //     width={'fit-content'}
    //     forceRender={true}
    //   >
    //     <GoalsDetails
    //       containers={unloads}
    //       goals={`${Math.round(goals_completed_tot)}/${Math.round(goals_tot)}`}
    //       settings={settings}
    //       isAgency={isAgency}
    //     />
    //   </Drawer>
    // </StyledIndividualStatsCard>
    <Spin spinning={loading}>
    <Card>
      <Row gutter={12} align="top" style={{ padding: '8px 8px 0 8px' }}>
        <Col span={10}>
          <SectionTitle>
            Shifts
            <Tooltip title={SHIFTS_TOOLTIP_TITLE} trigger="hover" placement="top">
              <span style={{ marginBottom: '-2px', marginLeft: '6px' }}>
                <Icon
                  name="info"
                  size={16}
                  strokeWidth={'3'}
                  color={'#A4B0BA'}
                />
              </span>
            </Tooltip>
          </SectionTitle>
        </Col>
        <Col span={14}>
          <SectionTitle>
            Inbound Performance
            <Tooltip title={INBOUND_PERFORMANCE_TOOLTIP_TITLE} trigger="hover" placement="top">
              <span style={{ marginBottom: '-2px', marginLeft: '6px' }}>
                <Icon
                  name="info"
                  size={16}
                  strokeWidth={'3'}
                  color={'#A4B0BA'}
                />
              </span>
            </Tooltip>
          </SectionTitle>
        </Col>
      </Row>

      <Row gutter={12} align="middle" style={{ padding: '0 8px' }}>
        <Col span={10}>
          <WorkingShiftsChart
            data={[
              { type: 'working shifts with people', value: workingShifts },
              { type: 'working shifts no people', value: Math.max(0, totShifts - workingShifts) },
            ]}
            totShifts={totShifts}
          />
        </Col>
        <Col span={14}>
          <WorkSegmentsBySpeedChart data={workSegmentsBySpeedData} />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <div style={{ height: 20, borderBottom: '1px solid #F0F0F0', margin: '12px 8px' }} />
        </Col>
      </Row>

      <Row gutter={12} style={{ padding: '0 8px 12px 8px' }} align="middle">
        <Col span={24}>
          <StyledStatsCard
            onlyMiddleDivider
            statistics={[
              {
                title: 'Work Segment Count',
                value: formatNumber(totSegments),
                titleAlign: ['center', 'bottom'],
              },
              {
                title: 'Total Time Detected',
                value: totalTimeDetectedHrs !== undefined ? formatDuration(totalTimeDetectedHrs * 3600000, false) : '-',
                titleAlign: ['center', 'bottom'],
              },
              {
                title: 'Average CPH',
                value: formatNumber(Math.round(avgCph || 0)),
                titleAlign: ['center', 'bottom'],
              },
              {
                title: 'Time Saved',
                value: timeSavedHrs !== undefined ? formatDuration(timeSavedHrs * 3600000, false) : '-',
                titleAlign: ['center', 'bottom'],
              },
              {
                title: 'Time Lost',
                value: timeLostHrs !== undefined ? formatDuration(timeLostHrs * 3600000, false) : '-',
                titleAlign: ['center', 'bottom'],
              },
              {
                title: 'Net Savings',
                value: formatDuration(netSavingsHrs * 3600000, false),
                titleAlign: ['center', 'bottom'],
              },
            ]}
          />
        </Col>
      </Row>
    </Card>
    </Spin>
  );
};

export default IndividualPeriodStats;
